<template>
  <div>
    <i class="fas fa-lock" /> Submission locked
    <button
      class="btn btn-outline-dark btn-sm"
      @click="openSubmission"
    >
      Unlock
    </button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
  },
  methods: {
    ...mapActions(['updateSlideActiveAction']),
    openSubmission() {
      this.updateSlideActiveAction({
        stopSubmission: false,
      })
      if (this.slideActive.timeToAnswer) {
        this.updateSlideActiveAction({
          stopSubmissionTime: new Date().getTime() +
            this.slideActive.timeToAnswer * 1000,
        })
      }
      this.$emit('updateSlide', {
        accessCode: this.presentation.uniqueAccessCode,
        stopSubmission: this.slideActive.stopSubmission,
        stopSubmissionTime: this.slideActive.stopSubmissionTime,
        timeToAnswer: this.slideActive.timeToAnswer,
        presentationId: this.presentation.id,
      }, 3)
    },
  },
}
</script>
